import {CostItem} from '@dms/api/core';

import {DEFAULT_CURRENCY_CODE} from '../../../../../constants/DEFAULT_CURRENCY_CODE';
import {CostsData} from '../components/CostsRow';

export const getNewCostItem = (newData: CostsData): CostItem => ({
  ...newData,
  cost: (newData.cost ?? 0).toString(),
  note: newData.note ?? '',
  currency: DEFAULT_CURRENCY_CODE,
  type: 'other',
});
